import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { useTranslation } from "react-i18next";
import RestInfoDialog from "../../../../Invs/BackEnd/models/RestInfo/RestInfoDialog";
import { Button } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 300,
    },
}));

export default function CheckRestrictionsTable(props) {
    const { data, database } = props;

    const stylH = {
        border: "solid 0.6px",
        borderColor: "black",
        borderStyle: "solid",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 15,
        color: "#fff"
    }
    const stylRo = {
        border: "solid 0.5px",
        borderColor: "#000",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 14,
        color: "#000"
    }

    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    const [infoData, setInfoData] = useState({ open: false, rest_id: 0, branch: 0 });

    return (
        <div>
            <TableContainer component={Paper} style={{ direction: "rtl" }}  >
                <Table
                    size="small" aria-label="a dense table" >
                    <TableHead>
                        <TableRow
                            style={{
                                backgroundColor:  "#808080",
                                color: "#000",
                                fontWeight: 800,
                                fontFamily: "Amiri-Regular",
                                fontSize: 15,
                                border: "solid 0.6px"
                            }}
                        >
                            <TableCell style={stylH} align="center">
                                {t("entry-no")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("doc-no")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("branch")}
                            </TableCell>
                            {/* <TableCell style={stylH} align="center">
                                {"Branch "}
                            </TableCell> */}
                            <TableCell style={stylH} align="center">
                                {t("total-debit")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("total-credit")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {"الفارق"}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {"عرض "}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row) => (
                            <TableRow key={row.ResId}
                                style={{
                                    padding: "5px 0px",
                                    textAlign: "-webkit-center",
                                    margin: "0px",
                                    whiteSpace: "nowrap",
                                    color: "#000",
                                    border: "solid 0.6px"
                                }}
                            >

                                <TableCell style={stylRo} align="right" >{row?.ResId}</TableCell>
                                {/* <TableCell style={stylRo} align="center" > {row?.ResDate}</TableCell> */}
                                <TableCell style={stylRo} align="center" > {row?.DocNo}</TableCell>
                                <TableCell style={stylRo} align="center" > {row?.BranchName}</TableCell>
                                <TableCell style={stylRo} align="center" > {parseFloat(row?.TotalDebit)?.toFixed(2)}</TableCell>
                                <TableCell style={stylRo} align="center" > {parseFloat(row?.TotalCredit)?.toFixed(2)}</TableCell>
                                <TableCell style={stylRo} align="center" > {row?.Difference?.toFixed(4)}</TableCell>

                                <TableCell style={stylRo} align="center">
                                    <>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            onClick={() => {
                                                setInfoData({ open: true, rest_id: row?.ResId, branch: row?.branch })
                                            }}
                                            style={{ backgroundColor: "#fff", color: "#000", fontWeight: "bold" }}
                                        >
                                            {t("journal-entry")}
                                        </Button>
                                    </>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {infoData.open &&
                <RestInfoDialog
                    infoData={infoData}
                    setInfoData={setInfoData}
                    res_id={infoData.rest_id}
                    branch={infoData.branch}
                    fromInv={0}
                    proc_id={0}
                    db_name={database?.name}
                />
            }
        </div>
    );
}
